<mat-progress-bar mode="indeterminate" *ngIf="!isDataLoaded" class="sdp-progress-bar"></mat-progress-bar>
<h2>
	{{ "summary.header.title" | translate }}
</h2>
<div class="sdp-section-header-description">{{ "summary.description" | translate }}.
</div>
<mat-card class="sdp-administrative-table-card">
	<sdp-generic-table [columnSchema]="columnSchema" [tableName]="'Summary'" [tableData]="data" [rows]="10"></sdp-generic-table>
</mat-card>